import { THEME } from 'components/theme'

export default {
  businessName: {
    fontSize: 16,
    color: THEME.brandBlack,
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  subtitle: {
    fontSize: 14
  },
  listItem: {
    height: 81,
    padding: '0 16px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    backgroundColor: THEME.brandWhite,
    borderBottom: `1px solid ${THEME.brandLightGrey}`,
    '&:hover': {
      backgroundColor: THEME.brandBGMedium
    }
  },
  container: {
    padding: '16px 0',
    border: 'none'
  }
}
